import Component from 'gia/Component';

export default class Header extends Component {
  constructor(element) {
    super(element);
    this.ref = {
      button: {},
      dropdown:{}
    };
  }

  mount() {
    let that = this;

    this.ref.button.addEventListener('click', function() {
      that.toggleDropdown();
    });

    document.addEventListener('click', function(event) {
      if (!that.ref.dropdown.contains(event.target) && !that.ref.button.contains(event.target)) {
        that.closeDropdown();
      }
    });
  }

  toggleDropdown() {
    this.ref.dropdown.classList.toggle('hidden');
  }

  closeDropdown() {
    this.ref.dropdown.classList.add('hidden');
  }
}